<template>
  <div class="container">
    <h1>Privacy Policy</h1>
    <div class="top-margin-30" style="text-align: left;">
      <p>GoldFire Studios, Inc. ("us", "we", or "our") operates the <a href="https://goldfire.me">https://goldfire.me</a> website/app (the "Service").</p>
      <p>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.</p>
      <p>We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from <a href="https://goldfire.me/terms">https://goldfire.me/terms</a>.</p>


      <a name="1"></a><p class="strong">1. Definitions</p>

      <strong>Personal Data</strong>
      <p>Personal Data means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).</p>

      <strong>Usage Data</strong>
      <p>Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</p>

      <strong>Cookies</strong>
      <p>Cookies are small pieces of data stored on a User’s device.</p>

      <strong>Data Controller</strong>
      <p>Data Controller means a person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed.</p>
      <p>For the purpose of this Privacy Policy, we are a Data Controller of your data.</p>

      <strong>Data Processor (or Service Providers)</strong>
      <p>Data Processor (or Service Provider) means any person (other than an employee of the Data Controller) who processes the data on behalf of the Data Controller.</p>
      <p>We may use the services of various Service Providers in order to process your data more effectively.</p>

      <strong>Data Subject</strong>
      <p>Data Subject is any living individual who is the subject of Personal Data.</p>

      <strong>User</strong>
      <p>The User is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.</p>


      <a name="2"></a><p class="strong">2. Information Collection And Use</p>

      <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>

      <strong>Personal Data</strong>
      <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</p>
      <ul>
      <li>Email address</li><li>Cookies and Usage Data</li>
      </ul>
      <p>We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or through your account settings.</p>

      <strong>Usage Data</strong>
      <p>We may also collect information how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>

      <strong>Tracking &amp; Cookies Data</strong>
      <p>We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.</p>
      <p>Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.</p>
      <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>
      <p>Examples of Cookies we use:</p>
      <ul>
        <li><strong>Session Cookies.</strong> We use Session Cookies to operate our Service.</li>
        <li><strong>Preference Cookies.</strong> We use Preference Cookies to remember your preferences and various settings.</li>
        <li><strong>Security Cookies.</strong> We use Security Cookies for security purposes.</li>
      </ul>


      <a name="3"></a><p class="strong">3. Use of Data</p>
      <p>GoldFire Studios, Inc. uses the collected data for various purposes:</p>
      <ul>
        <li>To provide and maintain our Service</li>
        <li>To notify you about changes to our Service</li>
        <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
        <li>To provide customer support</li>
        <li>To gather analysis or valuable information so that we can improve our Service</li>
        <li>To monitor the usage of our Service</li>
        <li>To detect, prevent and address technical issues</li>
        <li>To provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information</li>
      </ul>


      <a name="4"></a><p class="strong">4. Retention of Data</p>
      <p>GoldFire Studios, Inc. will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
      <p>GoldFire Studios, Inc. will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.</p>


      <a name="4"></a><p class="strong">5. Deletion of Data</p>
      <p>You have the right to delete your account and associated data at any time. To initiate the deletion process, please visit your account settings page and click on the "Delete Account" button. Upon confirming your decision, GoldFire Studios, Inc. will commence the deletion process, which will be completed within 30 days.</p>

      <p>During this 30-day period, your data will be marked for deletion, but you have the option to restore your account by logging back in before the completion of this timeframe. Once the 30-day period has elapsed, the deletion of your account and all associated data will be irreversible and permanent.</p>

      <p>Please be aware that GoldFire Studios, Inc. may retain certain information for a limited period as required by legal obligations, resolve disputes, and enforce our legal agreements and policies. However, this retained information will not be used for any other purpose and will be handled in accordance with the terms outlined in this Privacy Policy.</p>


      <a name="5"></a><p class="strong">6. Transfer of Data</p>
      <p>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.</p>
      <p>If you are located outside the United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to the United States and process it there.</p>
      <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>
      <p>GoldFire Studios, Inc. will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.</p>


      <a name="6"></a><p class="strong">7. Disclosure Of Data</p>
      <strong>Legal Requirements</strong>
      <p>GoldFire Studios, Inc. may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
      <ul>
        <li>To comply with a legal obligation</li>
        <li>To protect and defend the rights or property of GoldFire Studios, Inc.</li>
        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
        <li>To protect the personal safety of users of the Service or the public</li>
        <li>To protect against legal liability</li>
      </ul>


      <a name="7"></a><p class="strong">8. Security of Data</p>
      <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>


      <a name="8"></a><p class="strong">9. "Do Not Track" Signals</p>
      <p>We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.</p>
      <p>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</p>


      <a name="9"></a><p class="strong">10. Your Rights</p>
      <p>GoldFire Studios, Inc. aims to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.</p>
      <p>Whenever made possible, you can update your Personal Data directly within your account settings section. If you are unable to change your Personal Data, please contact us to make the required changes.</p>
      <p>If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please contact us or use the tools in your account settings.</p>
      <p>In certain circumstances, you have the right:</p>
      <ul>
        <li>To access and receive a copy of the Personal Data we hold about you</li>
        <li>To rectify any Personal Data held about you that is inaccurate</li>
        <li>To request the deletion of Personal Data held about you</li>
      </ul>
      <p>You have the right to data portability for the information you provide to GoldFire Studios, Inc.. You can request to obtain a copy of your Personal Data in a commonly used electronic format so that you can manage and move it.</p>
      <p>Please note that we may ask you to verify your identity before responding to such requests.</p>


      <a name="10"></a><p class="strong">11. Service Providers</p>
      <p>We may employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.</p>
      <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>

      <strong>Analytics</strong>
      <p>We may use third-party Service Providers to monitor and analyze the use of our Service.</p>    
      <ul>
        <li>
          <p><strong>Google Analytics</strong> - Their Privacy Policy can be viewed at <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a></p>
        </li>
        <li>
          <p><strong>Mixpanel</strong> - Their Privacy Policy can be viewed at <a href="https://mixpanel.com/legal/privacy-policy/">https://mixpanel.com/legal/privacy-policy/</a></p>
        </li>
      </ul>

      <strong>Payments</strong>
      <p>We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors).</p>
      <p>We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.</p>
      <p>The payment processors we work with are:</p>
      <ul>
        <li>
          <p><strong>Apple App Store</strong> - Their Privacy Policy can be viewed at <a href="https://www.apple.com/legal/privacy/en-ww/">https://www.apple.com/legal/privacy/en-ww/</a></p>
        </li>
        <li>
          <p><strong>Google Play Store</strong> - Their Privacy Policy can be viewed at <a href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a></p>
        </li>
        <li>
          <p><strong>Windows Store</strong> - Their Privacy Policy can be viewed at <a href="https://privacy.microsoft.com/en-us/privacystatement">https://privacy.microsoft.com/en-us/privacystatement</a></p>
        </li>
        <li>
          <p><strong>Steam</strong> - Their Privacy Policy can be viewed at <a href="https://store.steampowered.com/privacy_agreement/">https://store.steampowered.com/privacy_agreement/</a></p>
        </li>
        <li>
          <p><strong>Stripe</strong> - Their Privacy Policy can be viewed at <a href="https://stripe.com/us/privacy">https://stripe.com/us/privacy</a></p>
        </li>
        <li>
          <p><strong>PayPal</strong> - Their Privacy Policy can be viewed at <a href="https://www.paypal.com/webapps/mpp/ua/privacy-full">https://www.paypal.com/webapps/mpp/ua/privacy-full</a></p>
        </li>
        <li>
          <p><strong>Xsolla</strong> - Their Privacy Policy can be viewed at <a href="https://xsolla.com/privacypolicy/">https://xsolla.com/privacypolicy/</a></p>
        </li>
      </ul>


      <a name="11"></a><p class="strong">12. Links to Other Sites</p>
      <p>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>
      <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>


      <a name="12"></a><p class="strong">13. Children's Policy</p>
      <p>Our Service does not address anyone under the age of 13 ("Children").</p>
      <p>We do not knowingly collect personally identifiable information from anyone under the age of 13. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.</p>


      <a name="13"></a><p class="strong">14. Changes To This Privacy Policy</p>
      <p>We may make changes to this Privacy Policy from time to time. It is your responsibility to check each time you visit this Website for any updates. All changes are effective only from the date they are posted. The last date of revision (“Revision Date”) will always be posted below:
      <p>Revision Date: This Privacy Policy was last updated: May 2, 2018.</p>


      <a name="14"></a><p class="strong">15. Contact Us</p>
      <p>If you have any questions about this Privacy Policy, please contact us <a href="https://goldfire.me/contact">by e-mail</a> or at:</p>
      <p>
        GoldFire Studios, Inc.<br>
        100 N Broadway Ave, Ste. 2250<br>
        Oklahoma City, OK 73102<br>
        United States
      </p>

    </div>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  meta: {
    title: 'Privacy',
  },
  serverCacheKey() {
    return true;
  },
};
</script>
